import { createFileRoute, redirect } from '@tanstack/react-router';
import { ChangePasswordPage } from '../components/profile/ChangePasswordPage';

export const Route = createFileRoute('/profile/change-password')({
  beforeLoad: ({ location }) => {
    // Only authenticated users can change password
    if (!localStorage.getItem('access_token')) {
      throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
    }
  },
  component: ChangePasswordPage,
});
